import React from "react";
import { useState, useRef, useEffect } from "react";
import EmrConfigService from "../../../../services/EmrConfigService";
import EmrVisitsService from "../../../../services/EmrVisitsService";
import FieldsDisplay from "../EmrPages/FieldsDisplay";
import EmrFormRender from "../EmrPages/EmrFormRender";
import SearchHistory from "../EmrPages/SearchHistory";
import IcdDisplay from "./IcdDisplay";
import NewAssesmentTabForm from "./NewAssesmentTabForm";
import NewIcdDisplay from "./NewIcdDisplay";
import { convertUnderScoreStrings, toQueryString } from "../../../../utils/commonUtils";
import Icd10Service from "../../../../services/Icd10Service";
import IncidentService from "../../../../services/IncidentService";
import { inc } from "semver";
import EmrStatusBar from "../ComplaintPage/EmrStatusBar";

const NewAssesmentTab = (props) => {
  const {
    selectedSubTab,
    visit_id,
    setExpandedSection,
    fetchProgressNotesByScreen,
    Loader,
    Toast,
    employeeId,
    expandedSection,
    selectedTab,
    setSelecetedBodyParts,
    VISITCATEGORY,
    isChartingSectionDirty,
    setIsChartingSectionDirty,
    showUnsavedAlert,
    setShowUnsavedAlert,
    pendingCallback,
    setPendingCallback,
    checkUnsavedChanges,
    onDiagnosisRemoved, // Callback when diagnosis is removed
  } = props;

  // === State ===
  const [fields, setFields] = useState([]);
  const [selectedFormIds, setSelectedFormIds] = useState([]);
  const [formResponses, setFormResponses] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [progressApiTrigger, setProgressApiTrigger] = useState(0);
  const [fieldSearched, SetFieldSearched] = useState(false);
  const [activeSearchSource, setActiveSearchSource] = useState(null);
  const [normalCheckedFormIds, setNormalCheckedFormIds] = useState([]);
  const [formStates, setFormStates] = useState({});
  const [diagnoses, setDiagnoses] = useState(Array(12).fill(""));
  const [AllICDCodes, setAllICDCodes] = useState([]);
  const [incidentData, setIncidentData] = useState({});
  const [isFormDirty, setIsFormDirty] = useState(false);
  // === Refs ===
  const searchTimeoutRef = useRef(null);
  const historyRef = useRef(null);
  const formCache = useRef({});

  // === Effects ===
  // useEffect(() => {
  //   if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
  //   searchTimeoutRef.current = setTimeout(() => {
  //     if (searchTerm.trim() === "") fetchEmrList();
  //     else handleSearch();
  //   }, 500);
  //   return () => clearTimeout(searchTimeoutRef.current);
  // }, [searchTerm]);

  useEffect(() => {
    // fetchEmrList();
    setSearchTerm("");
  }, [selectedSubTab]);

  useEffect(() => {
    fetchProgressNotesByScreen();
  }, [visit_id, progressApiTrigger, selectedSubTab]);

  // useEffect(() => {
  //   fetchEmrList();
  // }, [props.selectedBodyPart]);
  useEffect(() => {
    fetchIcd10List();
    handleToggleIcd()
  }, [props.isrenderIncident]);

  // Refresh assessment data when refreshEmrTrigger changes (from Start Over)
  useEffect(() => {
    if (props.refreshEmrTrigger !== undefined && props.refreshEmrTrigger > 0) {
      handleToggleIcd();
      getIncidentById();
      // Reset form states
      setFormStates({});
      setDiagnoses(Array(12).fill(""));
      setSelectedIcdCodes([]);
      setIsFormDirty(false);
    }
  }, [props.refreshEmrTrigger]);
    const [selectedIcdCodes, setSelectedIcdCodes] = useState([]);
  
  // --- ADDED: Bubble up local dirty state to parent ---
  useEffect(() => {
    if(setIsChartingSectionDirty) {
        setIsChartingSectionDirty(isFormDirty);
    }
  }, [isFormDirty, setIsChartingSectionDirty]);
  const handleToggleIcd = async ( ) => {
      let prefilledData = {};
        try {
          const res = await EmrVisitsService.getAssessmentData(null, visit_id);
          prefilledData = res?.data || {};
          if (res?.data) {
            const normalizeList = (val) =>
              typeof val === "string" ? val.split(",").map((v) => v.trim()) : [];
            const normalized = {
              ...prefilledData,
              condition: normalizeList(prefilledData.condition),
              existing_problem: normalizeList(prefilledData.existing_problem),
              new_problem: normalizeList(prefilledData.new_problem),
            };
            setFormStates((prev) => ({
              ...prev,
              ...normalized,
            }));
            const diagnoses = Array.from({ length: 12 }, (_, i) => prefilledData[`diagnosis_${i + 1}`] || "");
            setDiagnoses(diagnoses);
          }
        } catch (err) {
          console.error(`Failed to fetch data :`, err);
        }

      // setSelectedIcdCodes((prev) => {
      //   const alreadyExists = prev.some((item) => item.code === icdCode);
      //   if (alreadyExists) return prev;
      //   return [...prev, { code: icdCode, icd_id: icd10_id ,body_parts:body_parts}];
      // });
  };

  // Refresh assessment when trigger changes (e.g., when AI suggestion is accepted)
  useEffect(() => {
    if (props.assessmentRefreshTrigger && props.assessmentRefreshTrigger > 0) {
      handleToggleIcd();
    }
  }, [props.assessmentRefreshTrigger]);
  const  getIncidentById=async()=>{
      try{
         Loader(true);
         const response = await IncidentService.getIncidentById(visit_id);
            
        if (response == null) {
      //     const employerName = this.props.employeeDetails.company.accounts_payable_contact_name
      //     const employeernumber = this.props.employeeDetails.company.accounts_payable_contact_phone
          const res = {
            ...incidentData,
          }
          setIncidentData(res)
        }
         if(response.incident_id && response.incident_id!==''){
          setIncidentData(response)  
          const diagnoses = Array.from({ length: 12 }, (_, i) => response[`diagnosis_${i + 1}`] || "");
          setDiagnoses(diagnoses);
          
         } 
     
      }catch(err){

      }finally{
         Loader(false);
      }
    }
  const  fetchIcd10List=async(term, callback = () => {})=>{
    
        try{
          const queryString = toQueryString({
            page: 1,
            perPage: 25,
            totalRecords: 0,
            sort_by: "code",
            sort_order: "asc",
            search: {
              search_query:term
            },
          });
           Loader(true);
           const response = await Icd10Service.getIcdList(queryString);
           if(response && response?.data.data){
              const options=response?.data.data.map((val)=>({
                label:`${val.code} - ${convertUnderScoreStrings(val.description)}`,
                value:val.icd10_id
              }))
         
              setAllICDCodes(options)
              callback(options)
           }
           
        }catch(err){
  
        }finally{
            Loader(false)
        }
      }
  const fetchFormDataById = async (apikey, id) => {
    // if (formCache.current[id]) return formCache.current[id];
    try {
      const response = await EmrConfigService.getEmrFormById(apikey, id);
      formCache.current[id] = response?.data;
      return response?.data;
    } catch (error) {
      console.error(`Failed to fetch form for ID: ${id}`, error);
      return null;
    }
  };

  const handleSearch = async (id, value, shouldSetFields = true) => {
    try {
      const payload = {
        field_search: searchTerm || "",
        common_search: "",
        history_value_search: "",
        id,
        value,
      };
      const results = await EmrVisitsService.fetchFieldsBySearch(
        null,
        selectedSubTab,
        payload
      );

      if (shouldSetFields) {
        const fieldsData = (results.data?.data || []).map((item) => ({
          emr_form_id: item.emr_form_id,
          name: item.name,
        }));
        SetFieldSearched(true);
        setFields(fieldsData);
      }
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  // const fetchEmrList = async () => {
  //   try {
  //     const response = await EmrVisitsService.getEmrChartByScreen(
  //       selectedSubTab,
  //       visit_id,
  //       { is_active: 1, selected_BodyParts: props.selectedBodyPart || "" }
  //     );
  //     let fieldsData = [];
  //     let selectedIds = [];
  //     let normalIds = [];
  //     response.data.forEach((itm) => {
  //       fieldsData.push({ emr_form_id: itm.emr_form_id, name: itm.name });
  //       if (itm.is_chart) selectedIds.push(itm.emr_form_id);
  //       if (itm.is_normal) normalIds.push(itm.emr_form_id);
  //       if (itm.is_chart) handleCheckboxChange(itm.emr_form_id, true);
  //     });
  //     setSelectedFormIds(selectedIds);
  //     setNormalCheckedFormIds(normalIds);
  //     setFields(fieldsData);
  //     return fieldsData;
  //   } catch (e) {
  //     console.error("Fetch EMR Error:", e);
  //     return [];
  //   }
  // };

  const handleCheckboxChange = async (
    emr_form_id,
    checked,
    replace = false
  ) => {
    setSelectedFormIds((prev) =>
      checked
        ? Array.from(new Set([...prev, emr_form_id]))
        : prev.filter((id) => id !== emr_form_id)
    );

    if (checked) {
      try {
        const form = await fetchFormDataById(selectedSubTab, emr_form_id);
        const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
          null,
          visit_id,
          emr_form_id
        );
        const filledFields = filledDataRes?.data?.data?.emr_field || [];
        const filledFieldMap = {};
        filledFields.forEach((field) => {
          field.id.forEach((id) => {
            filledFieldMap[id] = field.value;
          });
        });
        const prefilledForm = {
          ...form,
          fields: form.fields.map((field) => ({
            ...field,
            prefillValue: filledFieldMap[field.id] || "",
          })),
        };
        setFormResponses((prev) => {
          if (replace) return { ...prev, [selectedSubTab]: [prefilledForm] };
          const prevList = prev[selectedSubTab] || [];
          if (
            prevList.some(
              (formItem) => formItem.emr_form_id === prefilledForm.emr_form_id
            )
          )
            return prev;
          return { ...prev, [selectedSubTab]: [...prevList, prefilledForm] };
        });
      } catch (error) {
        console.error("Error fetching prefilled field data:", error);
      }
    } else {
      handleNormalSubmit(emr_form_id, 0, 1);
      setFormResponses((prev) => {
        const updated = (prev[selectedSubTab] || []).filter(
          (form) => form?.emr_form_id !== emr_form_id
        );
        return { ...prev, [selectedSubTab]: updated };
      });
    }
  };

  const handleNormalSubmit = async (form_id, isNormal = 0, is_clear = 0, clearAll = 0) => {
    try {
      const payload = {
        employee_id: employeeId,
        screen_type: selectedSubTab,
        emr_field: "",
        is_normal: isNormal,
        chart_update: 0,
        is_clear: is_clear,
        clear_all: clearAll, // Add clear_all parameter
      };
      Loader(true);
      const result = await EmrVisitsService.saveFields(
        null,
        visit_id,
        form_id,
        payload
      );
      Loader(false);
      if (result?.status === 200 || result?.status === "SUCCESS") {
        if (isNormal === 1) {
          Toast.success("Marked as normal successfully.");
          fetchProgressNotesByScreen();
        }
      } else {
        Toast.error("Failed to mark as normal.");
      }
    } catch (err) {
      Loader(false);
      console.error("Normal save failed:", err);
      Toast.error("Something went wrong.");
    }
  };

  const handleFormUpdate = async (form_id) => {
    try {
      const form = await fetchFormDataById(selectedSubTab, form_id);
      const filledDataRes = await EmrVisitsService.fetchFilledFieldData(
        null,
        visit_id,
        form_id
      );
      const filledFields = filledDataRes?.data?.data?.emr_field || [];
      const filledFieldMap = {};
      filledFields.forEach((field) => {
        field.id.forEach((id) => {
          filledFieldMap[id] = field.value;
        });
      });
      const updatedForm = {
        ...form,
        fields: form.fields.map((field) => ({
          ...field,
          prefillValue: filledFieldMap[field.id] || "",
        })),
      };
      setFormResponses((prev) => {
        const prevList = prev[selectedSubTab] || [];
        const updatedList = prevList.map((f) =>
          f.emr_form_id === form_id ? updatedForm : f
        );
        return { ...prev, [selectedSubTab]: updatedList };
      });
    } catch (err) {
      console.error("Failed to refresh filled form:", err);
    }
  };

  const allSelected =
    fields.length > 0 &&
    fields.every((f) => selectedFormIds.includes(f.emr_form_id));


  const handleComplete = () => {
    setIsFormDirty(false);
    props.SetFinishedTabs((prev) => (Array.from(new Set([...prev, props.selectedTab]))))
    props.SetFinishedSubTabs((prev) => (Array.from(new Set([...prev, props.selectedSubTab]))))
    handleTick(Array.from(new Set([...props.finishedTabs, props.selectedTab])), Array.from(new Set([...props.finishedSubTabs, props.selectedSubTab])))
  }
  const handleIncomplete = () => {
    setIsFormDirty(false);
    props.SetFinishedTabs((prev) => prev.filter(tab => tab !== props.selectedTab))
    props.SetFinishedSubTabs((prev) => prev.filter(subtab => subtab !== props.selectedSubTab))
    handleTick(
      props.finishedTabs.filter(tab => tab !== props.selectedTab), 
      props.finishedSubTabs.filter(subtab => subtab !== props.selectedSubTab)
    )
  }
   const handleTick=async(maintabs,subtabs)=>{
          try{
            
            const payload = props.tabData.map((tab) => ({
              ...tab,
              tab_status: maintabs.includes(tab.tab_name) ? "COMPLETED" : "NOT STARTED",
              [tab.tab_name]: tab[tab.tab_name]?.map((subtab) => ({
                ...subtab,
                sub_tab_status: subtabs.includes(subtab.apikey)
                  ? "COMPLETED"
                  : "NOT STARTED",
              })) || [],
            }));
            const response = await EmrConfigService.setTabsListstatus(props.visit_id,payload,props.VISITCATEGORY)
            if(response){
              props.fetchTabsList()
            }
          }catch(err){
      
          }finally{
      
          }
        }
  return (
    // <div className="sh_cardBody" style={{ height: "calc(40vh - 120px)" }}>
    <>
      <div className="row">
          <div className="sh_cardHeader mb-3 rounded-2" style={{ background: "linear-gradient(90deg, #FFF7DC 0%, #F7E9E5 100%)",}}>
            <div className="d-flex justify-content-center">
              <div className="form-group d-flex mb-0 justify-content-between align-items-center">
               <EmrStatusBar visitDetails={props.visitDetails} />
              </div>
            </div>
          </div>
        <NewIcdDisplay
        isrenderICD={props.isrenderICD}
        bodyparts={props.selectedBodyPart}
        onToggle={handleToggleIcd}
        selectedCodes={selectedIcdCodes}
        profile={props.profile}
        organizationId={props.organizationId || props.organization_id || props.organizationuuid || props.visitDetails?.organization_id}
        refreshAssessmentModel={handleToggleIcd}
        visit_id={visit_id}
        setSelecetedBodyParts={setSelecetedBodyParts}
        setSelectedIcdCodes={setSelectedIcdCodes}
        Loader={Loader}
        Toast={Toast}
        setDiagnoses={setDiagnoses}
        diagnoses={diagnoses}
        setIncidentData={setIncidentData}
        setFormStates={setFormStates}
        setIsFormDirty={setIsFormDirty}
        /> 
        {/* second column */}
        {/* <FieldsDisplay
          fields={fields}
          normalCheckedFormIds={normalCheckedFormIds}
          handleNormalSubmit={handleNormalSubmit}
          setNormalCheckedFormIds={setNormalCheckedFormIds}
          setSelectedFormIds={setSelectedFormIds}
          selectedFormIds={selectedFormIds}
          handleCheckboxChange={handleCheckboxChange}
          fieldSearched={fieldSearched}
          handleSearch={handleSearch}
          SetFieldSearched={SetFieldSearched}
          allSelected={allSelected}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setActiveSearchSource={setActiveSearchSource}
          activeSearchSource={activeSearchSource}
          selectedTab={selectedTab}
        /> */}

        {/* third column */}
        {/* <EmrFormRender
          setProgressApiTrigger={setProgressApiTrigger}
          fetchProgressNotesByScreen={fetchProgressNotesByScreen}
          fields={(formResponses[selectedSubTab] || []).filter((form) =>
            selectedFormIds.includes(form.emr_form_id)
          )}
          visit_id={visit_id}
          employeeId={employeeId}
          Toast={Toast}
          expandedSection={expandedSection}
          setExpandedSection={setExpandedSection}
          selectedSubTab={selectedSubTab}
          onFormUpdate={handleFormUpdate}
          isAssessment={true}
        /> */}
        <NewAssesmentTabForm
          visit_id={visit_id}
          Toast={Toast}
          Loader={Loader}
          employee_id={employeeId}
          selectedIcdCodes={selectedIcdCodes}
          formStates={formStates}
          setFormStates={setFormStates}
          setProgressApiTrigger={setProgressApiTrigger}
          icd10List={AllICDCodes}
          diagnoses={diagnoses}
          setDiagnoses={setDiagnoses}
          incidentData={incidentData}
          setIncidentData={setIncidentData}
          handleComplete={handleComplete}
          handleIncomplete={handleIncomplete}
          VISITCATEGORY={VISITCATEGORY}
          fetchIcd10List={fetchIcd10List}
          handleToggleIcd={handleToggleIcd}
          isFormDirty={isFormDirty}
          setIsFormDirty={setIsFormDirty}
          showUnsavedAlert={showUnsavedAlert}
          setShowUnsavedAlert={setShowUnsavedAlert}
          pendingCallback={pendingCallback}
          setPendingCallback={setPendingCallback}
          setIsChartingSectionDirty={setIsChartingSectionDirty}
          onDiagnosisRemoved={onDiagnosisRemoved}
        />
      </div>
  </>
  );
};

export default NewAssesmentTab;
